module.exports = __webpack_public_path__ + "img/shape_positivo.5d1fad34.svg";